import * as React from "react";
import { cn } from "../primitives/cn";

export type CrudPageVariant = "fluid" | "form" | "wizard" | "detail";

export function CrudPageLayout({
  variant = "form",
  children,
  className,
}: {
  variant?: CrudPageVariant;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={cn(
      "mx-auto w-full space-y-6 px-4 pb-8 sm:px-6 lg:px-8",
      variant === "form" && "max-w-3xl",
      variant === "wizard" && "max-w-4xl",
      variant === "detail" && "max-w-5xl",
      variant === "fluid" && "max-w-none",
      className,
    )}>
      {children}
    </div>
  );
}

export function CrudFormCard({ children, className }: { children: React.ReactNode; className?: string }) {
  return <div className={cn("rounded-xl border border-border bg-card p-4 shadow-sm sm:p-6", className)}>{children}</div>;
}
